module.exports = __webpack_public_path__ + "static/media/icon.2593f2cb.svg";